import * as R from 'ramda';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import allAvailableImagesFixtures from './fixtures/all-available-images';
import Publication from '@app/publication';
import publicationsFixtures from './fixtures/publications';
import Section from '@app/section';
import settings from '@app/app.settings';
declare const _user: any;

@Injectable()
export class AppService {
  private activePublicationSource = new BehaviorSubject<Publication | null>(null);
  activePublication$ = this.activePublicationSource.asObservable();
  apiKey = _user.centralUser.apiKey || environment.APIKey;

  addSection(params: {data: Section, publicationId: string}) {
    if (environment.isLocal) {
      return of({
        id         : Math.floor(Math.random() * (10000 - 7000)) + 7000,
        sources    : [],
        subsections: [],
        title      : params.data.title,
      });
    }

    this.http.post(
      `${environment.APIUrl}
      ${settings.publicationSectionsAPI({publicationId: params.publicationId})}?apiKey=${environment.APIKey}`,

      params.data,
    );
  }

  deleteSection(params: {sectionId: number, publicationId: string}) {
    if (environment.isLocal) {
      return of({});
    }

    this.http.delete(
      `${environment.APIUrl}${settings.publicationSectionsAPI(params.publicationId)}` +
      `?apiKey=${environment.APIKey}&sectionId=${params.sectionId}`,
    );
  }

  constructor(private http: HttpClient) { }

  getAllAvailableImages() {
    if (environment.isLocal) {
      return of(allAvailableImagesFixtures);
    }

    return this.http.get(
      `${environment.APIUrl}${settings.allAvailableArticleImagesAPI()}`,
      {params: {apiKey: this.apiKey}},
    );
  }

  getPublications() {
    if (environment.isLocal) {
      return of(publicationsFixtures);
    }

    return this.http.get(
      `${environment.APIUrl}${settings.publicationsAPI()}`,
      {params: {apiKey: this.apiKey}},
    );
  }

  getPublication(params) {
    if (environment.isLocal) {
      return of(R.find(R.propEq('id', params.id), publicationsFixtures.publications));
    }

    return this.http.get(
      `${environment.APIUrl}${settings.publicationAPI({id: params.id})}`,
      {params: {apiKey: this.apiKey}},
    );
  }

  savePublicationSection(params) {
    return this.http.post(
      `${environment.APIUrl}${settings.publicationSectionAPI(R.pick(['publicationId', 'sectionId'], params))}?apiKey=${this.apiKey}`,
      JSON.stringify(params.data),
    ).subscribe();
  }

  setActivePublication(publication: Publication) {
    this.activePublicationSource.next(publication);
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/app.service.ts